export default __webpack_public_path__ + "static/media/1801.2f1d6652.png";